import { Info } from 'lucide-react';
import { type CSSProperties, type MouseEvent, type ReactNode, useState } from 'react';

import TransitionPortal from '@/components/Common/TransitionPortal';
import zIndex from '@/styles/zIndex';

type Props = {
  tooltip?: {
    content?: ReactNode;
    offset?: {
      top?: number;
      left?: number;
    };
  };
};

export const GuideInfo = (props: Props) => {
  const [infoState, setInfoState] = useState<{
    status: boolean;
    pos: CSSProperties;
  }>({
    status: false,
    pos: {},
  });

  const openSentimentInfo = (e: MouseEvent<HTMLDivElement>) => {
    const { top, right } = e.currentTarget.getBoundingClientRect();

    setInfoState({
      status: true,
      pos: {
        zIndex: zIndex.popup,
        top: top + (props.tooltip?.offset?.top || 0),
        right: window.innerWidth - right + (props.tooltip?.offset?.left || 0),
      },
    });
  };
  const closeSentimentInfo = () => {
    setInfoState((prev) => ({
      ...prev,
      status: false,
    }));
  };

  return (
    <>
      <div
        onClick={openSentimentInfo}
        className="cursor-pointer p-1 hover:bg-gray-200 rounded-md"
      >
        <Info size={14} className="text-gray-600" />
      </div>
      {props.tooltip?.content && (
        <TransitionPortal
          layerId="syncly-popup-layer"
          status={infoState.status}
          style={infoState.pos}
          close={closeSentimentInfo}
        >
          {props.tooltip.content}
        </TransitionPortal>
      )}
    </>
  );
};
